import styled from 'styled-components';

export default styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: var(--red);
`;
